export class DataQualityDashboardSection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "widgets",
            "baseName": "widgets",
            "type": "Array<Widget>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataQualityDashboardSection.attributeTypeMap;
    }
    constructor() {
    }
}
